import React from 'react';

// Helpers
import * as UserHelper from 'Shared/model_helpers/User.helpers';

// Components
import { WpModal, WpModalBody, WpModalHeader } from 'Wpds/components/modal';

// Styles
import './SomeoneIsTypingModal.scss';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  typingParticipants;
};

const SomeoneIsTypingModal = ({ typingParticipants, isOpen, toggleIsOpen }: Props) => {
  const names = typingParticipants
    .valueSeq()
    .map(user => UserHelper.getFirstName(user))
    .toJS();

  let text = `${typingParticipants.size} attendees are`;

  if (typingParticipants.size === 1) {
    text = `${names[0]} is `;
  }
  if (typingParticipants.size === 2) {
    text = `${names[0]} and ${names[1]} are`;
  }

  const showTypingList = typingParticipants.size > 2;

  const baseClassName = 'SomeoneIsTypingModal';
  return (
    <WpModal size="sm" isOpen={isOpen} onToggle={toggleIsOpen}>
      <WpModalHeader>Waiting...</WpModalHeader>
      <WpModalBody>
        <div className={baseClassName}>
          <span>{`${text} still recording notes, waiting for them to finish before continuing on.`}</span>
          {showTypingList && (
            <div className={`${baseClassName}__typing-participants-snippet`}>
              {names.map((name, index) => {
                const isLast = index === names.length - 1;
                const isNextToLast = index === names.length - 2;
                return (
                  <span key={`typing-participants-snippet-${name}-${index}`}>
                    {name}
                    {isNextToLast && ' and '}
                    {!isLast && !isNextToLast && ', '}
                  </span>
                );
              })}
            </div>
          )}
        </div>
      </WpModalBody>
    </WpModal>
  );
};

export default SomeoneIsTypingModal;
